import { render, staticRenderFns } from "./TrScratch.vue?vue&type=template&id=15636110&scoped=true&"
import script from "./TrScratch.vue?vue&type=script&lang=js&"
export * from "./TrScratch.vue?vue&type=script&lang=js&"
import style0 from "./TrScratch.vue?vue&type=style&index=0&id=15636110&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15636110",
  null
  
)

export default component.exports